import React, {Fragment} from 'react';

export default function(){
    return(
        <Fragment>
            <h1>Copy Number Variations</h1>
            <p>
               
            </p>
            <p>
              
            </p>
        </Fragment>
    )
}